import React from "react";
import { Check, Clipboard } from "lucide-react";

function WebhookField({label,description,hint,value,type = "text",copied,onCopy}) {
  return (
    <div className="rounded-[18px] border border-[#dfeaf0] bg-white p-3.5 sm:p-4 dark:border-dark-border dark:bg-dark-surface">
      {/* Label */}
      <div className="mb-2.5 flex items-center justify-between gap-3">
        <label className="text-[10px] font-bold text-[#344f61] dark:text-dark-text-primary">
          {label}
        </label>
        <span className="rounded-full bg-[#edf3f6] px-2 py-1 text-[8px] font-semibold text-[#8194a0] dark:bg-dark-card dark:text-dark-text-muted">
          {hint}
        </span>
      </div>

      {/* Input */}
      <div
        className="flex h-11 overflow-hidden rounded-xl border border-[#c9dce4] bg-[#f8fbfc] transition focus-within:border-[#147db5] focus-within:ring-4 focus-within:ring-[#147db5]/[0.08] dark:border-dark-border dark:bg-dark-bg">
        <input
          type={type}
          value={value || ""}
          readOnly
          className="min-w-0 flex-1 bg-transparent px-3 text-[10px] font-medium text-[#425f72] outline-none sm:text-[11px] dark:text-dark-text-secondary"
        />

        <button
          type="button"
          onClick={onCopy}
          className="flex w-11 shrink-0 items-center justify-center border-l border-[#c9dce4] text-[#8194a0] transition hover:bg-white hover:text-[#147db5] dark:border-dark-border dark:hover:bg-dark-soft-blue dark:hover:text-dark-primary"
          title={`Copy ${label}`}
        >
          {
          copied ? (<Check size={14} className="text-emerald-500"/>) : (<Clipboard size={14} />)
          }
        </button>
      </div>

      {/* Description */}
      <p className="mt-2 text-[9px] leading-4 text-[#8194a0] dark:text-dark-text-muted">
        {description}
      </p>
    </div>
  );
}

export default WebhookField;
